import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const setGlobalTimezone = (timezone: string) => dayjs.tz.setDefault(timezone)

export default dayjs.tz